import { render, staticRenderFns } from "./wrehouseTransferOrder.vue?vue&type=template&id=2ca6f94f&"
import script from "./wrehouseTransferOrder.vue?vue&type=script&lang=js&"
export * from "./wrehouseTransferOrder.vue?vue&type=script&lang=js&"
import style0 from "./wrehouseTransferOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports